import React from 'react';
import { withStyles, TextField } from '@material-ui/core';
import { colors } from '@lifesize/ux-assets';

const MuiTextField = ({ input, label, inputProps, meta: { touched, error, invalid }, ...custom }) => {
  return (
    <TextField
      {...custom}
      onChange={(e) => input.onChange(e)}
      type={'text'}
      helperText={error}
      fullWidth
      label={label}
      InputLabelProps={{
        disableAnimation: true
      }}
      inputProps={{ ...inputProps }}
      error={invalid}
      name={input.name}
      value={input.value}
    />
  );
};

// outlined style for guest flow.
export default withStyles(() => ({
  root: {
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: colors.lifesizeBlue
      },
      '& fieldset': {
        borderRadius: 0,
        borderWidth: '2px',
        borderColor: colors.concrete
      }
    }
  }
}))(MuiTextField);
